<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import Withdraw from 'src/components/cabinet/confirmations/components/Withdraw.svelte'
    import IncreaseDecrease from 'src/components/cabinet/confirmations/components/IncreaseDecrease.svelte'
    import Memberships from 'src/components/cabinet/confirmations/components/Memberships.svelte'

    let tabs = [
        'withdraw',
        'membership',
        'balance'
    ]
    let selected = tabs[0]
</script>

<svelte:head>
    <title>Confirmations</title>
</svelte:head>

<MainLayout title="Confirmations">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <ul class="nav nav-tabs nav-bordered mb-3">
                    <li class="nav-item">
                        <div class="nav-link" class:active={selected === 'withdraw'} on:click={()=>selected = tabs[0]}>
                            <span>Withdrawals</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link" class:active={selected === 'membership'} on:click={()=>selected = tabs[1]}>
                            <span>Memberships</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link" class:active={selected === 'balance'} on:click={()=>selected = tabs[2]}>
                            <span>Increase & Decrease</span>
                        </div>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active">
                        {#if selected === 'withdraw'}
                            <Withdraw/>
                        {:else if selected === 'membership'}
                            <Memberships/>
                        {:else if selected === 'balance'}
                            <IncreaseDecrease/>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .nav-tabs .nav-link {
        user-select: none;
        cursor: pointer;
    }

    .nav-tabs .nav-link.active {
        color: white;
        background-color: #FF5D1C;
        border-color: transparent transparent #FF5D1C;
        cursor: default;
    }
</style>
